function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "_13-transfer",
  "data-name": "13-transfer"
}, /*#__PURE__*/React.createElement("g", {
  id: "linear_color",
  "data-name": "linear color",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("path", {
  d: "M32,454a10,10,0,0,0,0,20H224a10,10,0,0,0,0-20h-6V361h6a10,10,0,0,0,10-10V336a10,10,0,0,0-4.453-8.32l-96-64a10,10,0,0,0-11.094,0l-96,64A10,10,0,0,0,22,336v15a10,10,0,0,0,10,10h6v93Zm58-92h76v92H90Zm96,92V362h12v92ZM128,284.019,213.472,341H42.528ZM58,362H70v92H58Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M240,486H16a10,10,0,0,0,0,20H240a10,10,0,0,0,0-20Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M288,200a10,10,0,0,0,0,20H480a10,10,0,0,0,0-20h-6V107h6a10,10,0,0,0,10-10V82a10,10,0,0,0-4.453-8.32l-96-64a10,10,0,0,0-11.094,0l-96,64A10,10,0,0,0,278,82V97a10,10,0,0,0,10,10h6v93Zm58-92h76v92H346Zm96,92V108h12v92ZM384,30.019,469.473,87H298.527ZM314,108h12v92H314Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M496,232H272a10,10,0,0,0,0,20H496a10,10,0,0,0,0-20Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M429.129,289.2a10,10,0,0,0-12.136,7.26A165.381,165.381,0,0,1,298.061,416.607l12.247-22.894a10,10,0,0,0-17.635-9.434L270.031,426.6a10,10,0,0,0,4.285,13.631l42.8,21.76a10,10,0,1,0,9.065-17.828l-18.6-9.457A185.863,185.863,0,0,0,436.39,301.339,10,10,0,0,0,429.129,289.2Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M82.872,222.8a9.984,9.984,0,0,0,12.135-7.26A165.383,165.383,0,0,1,213.939,95.393l-12.247,22.894a10,10,0,1,0,17.635,9.434L241.969,85.4a10,10,0,0,0-4.285-13.631l-42.8-21.76a10,10,0,1,0-9.065,17.828l18.6,9.457A185.86,185.86,0,0,0,75.611,210.661,10,10,0,0,0,82.872,222.8Z"
})));

var SvgBankOffice = function SvgBankOffice(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 512 512",
    width: 31.5,
    height: 31.5,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgBankOffice, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/bankOffice.06e98ba1.svg";
export { ForwardRef as ReactComponent };